<template>
  <v-dialog v-model="dialog2" max-width="50%">
    <v-card>
      <v-card-title>
        COMPETÊNCIA: {{ invoice.competence | formatCompetence }}
      </v-card-title>
      <v-card-text style="text-align: center">
        <v-form
          v-if="!uploadEnd"
          ref="form"
          v-model="valid"
          lazy-validation
          class="form_class"
        >
          <v-btn
            block
            color="success"
            @click.native="selectFile"
            v-if="!uploadEnd && !uploading"
          >
            <v-icon left aria-hidden="true">add_a_photo</v-icon>ADICIONAR CONTA
            DE ENERGIA
          </v-btn>
          <input
            id="files"
            type="file"
            capture="camera"
            name="file"
            ref="uploadInput"
            accept="application/pdf"
            :multiple="false"
            @change="detectFiles($event)"
          />
          <v-progress-circular
            v-if="uploading && !uploadEnd"
            :size="100"
            :width="15"
            :rotate="360"
            :value="progressUpload"
            color="success"
            >%</v-progress-circular
          >
        </v-form>
        <div v-if="fileType === 'application/pdf' && uploadEnd">
          Arquivo adicionado com sucesso!
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="dialog2 = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { eventBus } from "../../main";
import { firestorage } from "@/firebase/firestorage";
import { updateInvoice } from "../../services/invoices";

export default {
  data() {
    return {
      valid: false,
      progressUpload: 0,
      fileName: "",
      fileType: "",
      fileUrl: "",
      uploadTask: "",
      bufferFile: "",
      uploading: false,
      uploadEnd: false,
      downloadURL: "",
      invoice: {},
      customer_id: "",
      dialog2: false,
      fileBase64: "",
    };
  },
  created() {
    eventBus.$on("invoiceSelected", (invoice) => {
      this.invoice = invoice;
      if (invoice) this.dialog2 = true;
    });
    eventBus.$on("customer_id", (customer_id) => {
      this.customer_id = customer_id;
    });
  },
  filters: {
    formatCompetence(value) {
      const year = String(value).split("-")[0];
      const mounth = String(value).split("-")[1];
      return mounth + "/" + year;
    },
  },
  methods: {
    selectFile() {
      this.$refs.uploadInput.click();
    },
    detectFiles(e) {
      let fileList = e.target.files || e.dataTransfer.files;
      Array.from(Array(fileList.length).keys()).map((x) => {
        this.upload(fileList[x], this.invoice, this.customer_id);
      });
    },
    upload(file, invoice, customer_id) {
      this.fileName = file.name;
      this.fileType = file.type;
      const year_competence = invoice.competence.split("-")[0];
      const month_competence = invoice.competence.split("-")[1];
      this.fileUrl =
        "/contas/" +
        year_competence +
        "/" +
        month_competence +
        "/" +
        customer_id +
        "/" +
        this.fileName;
      this.uploading = true;

      //Upload da conta do usuário
      this.uploadTask = firestorage.ref(this.fileUrl).put(file);

      // Transformar em Base64String
      var reader = new FileReader();
      reader.onload = function (e) {
        //Converting Binary Data to base 64
        var base64String = e.target.result.split(",")[1];

        const newInvoice = {
          competence: year_competence + "-" + month_competence,
          bill_base64String: base64String,
          updated_at: new Date(),
        };
        // Save data in Invoice
        updateInvoice(customer_id, newInvoice)
          .then(() => {
            // this.invoice.bill_base64String = base64String
            this.uploadEnd = true;
            this.uploading = false;
          })
          .catch((error) => {
            console.error(
              "Ocorreu um erro durante a atualização da fatura: ",
              error,
            );
          });
        return base64String;
      };
      reader.readAsDataURL(file);
    },
  },
  watch: {
    uploadTask: function () {
      this.uploadTask.on(
        "state_changed",
        (sp) => {
          this.progressUpload = Math.floor(
            (sp.bytesTransferred / sp.totalBytes) * 100,
          );
        },
        null,
        () => {
          this.uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            const year_competence = this.invoice.competence.split("-")[0];
            const month_competence = this.invoice.competence.split("-")[1];
            const newInvoice = {
              competence: year_competence + "-" + month_competence,
              bill_url: downloadURL,
            };
            // Save data in Invoice
            this.invoice.bill_url = downloadURL;
            updateInvoice(this.customer_id, newInvoice)
              .then(() => {
                // console.log('Arquivo adicionado com sucesso!')
                this.uploading = false;
              })
              .catch((error) => {
                console.error(
                  "Ocorreu um erro durante a atualização da fatura: ",
                  error,
                );
              });

            this.uploadEnd = true;
            this.uploading = false;
            this.downloadURL = downloadURL;
            this.$emit("downloadURL", downloadURL);
          });
        },
      );
    },
  },
};
</script>
<style scoped>
.progress-bar {
  margin: 10px 0;
}
input[type="file"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}
</style>
